import React, { useState } from 'react';
import { Box, IconButton, SvgIconProps, useMediaQuery, useTheme } from '@material-ui/core';
import { ExternalLinkIcon, ToggleableChevron, Typography, UnicodeEntity } from '../../../ui-kit';
import { usePriceService } from '../../../utils/hooks/priceService';
import { useUser } from '../../../utils/hooks/auth';
import { colorMap } from './constants';
import { Accordion, AccordionDetails, AccordionSummary, CircleIconContainer, LinkContainer } from './style';

interface AccordionRowProps {
    Icon: React.ComponentType<SvgIconProps>;
    color: keyof typeof colorMap;
    title: string;
    amount: number;
    linkUrl?: string;
    appendMinusToAmount?: boolean;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const AccordionRow: React.FC<AccordionRowProps> = ({ Icon, color, title, amount, children, linkUrl, appendMinusToAmount }) => {
    const [isOpen, setIsOpen] = useState(false);
    const { priceService } = usePriceService();
    const { user: { defaultCurrency: { currencyCode } } } = useUser();

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
    const handleAccordionToggle = () => {
        setIsOpen(!isOpen);
    };

    const hasToggleableContent = !!children;

    return (
        <Accordion expanded={isOpen}>
            <AccordionSummary>
                <Box display='grid' gridGap={16} gridAutoFlow='column' justifyContent='space-between' flexGrow={1} alignItems='center'>
                    <Box display='grid' gridGap={8} gridAutoFlow='column' alignItems='center'>
                        {isMobile
                        ? null
                        : (
                            <CircleIconContainer color={color}>
                                <Icon />
                            </CircleIconContainer>
                        )}
                        <Typography>{title}</Typography>
                        {hasToggleableContent
                            ? (
                                <IconButton style={{ background: 'transparent', padding: '0 8px' }} onClick={handleAccordionToggle}>
                                    <ToggleableChevron open={isOpen} />
                                </IconButton>
                            ): null}
                    </Box>
                    <Box display='grid' gridGap={8} gridAutoFlow='column' alignItems='center'>
                        <Typography variant={isMobile ? 'body2' : 'subtitle1'} style={{ color: colorMap[color] }}>
                            {appendMinusToAmount ? UnicodeEntity.MinusSign : null}
                            {priceService.toLocaleString(amount, currencyCode)}
                        </Typography>
                        {linkUrl
                            ? (
                                <LinkContainer href={linkUrl} to={linkUrl}>
                                    <ExternalLinkIcon />
                                </LinkContainer>
                            ) : null}
                    </Box>
                </Box>
            </AccordionSummary>
            {hasToggleableContent
                ?(
                    <AccordionDetails>
                        <Box ml='38px' display='grid' gridGap={8}>
                            {children}
                        </Box>
                    </AccordionDetails>

                ): null}
        </Accordion>
    );
};

export default AccordionRow;